import { IconButton, Typography } from '@mui/material';
import { Box } from '@mui/system';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { sendReceipt } from '../../../api/receipt-api';
import BackIcon from '../../../assets/icons/arrow-left-icon.svg';
import { LANG_TEXT } from '../../../constants/language';
import { useNotificationContext } from '../../../context/notificationContext';
import { Order, OrderItemStatus } from '../order.types';
import ActionButton from './components/ActionButton';
import OrderIdSection from './components/OrderIdSection';
import OrderSummary from './components/OrderSummary';
import PaymentMethod from './components/PaymentMethod';
import PaymentSummary from './components/PaymentSummary';
import SeatInfor from './components/SeatInfor';
import Transition from './components/Transition';
import { CustomDrawer } from './styles';

interface DeliveryInfoProps {
  item?: Order;
  open: boolean;
  onClose: () => void;
  onPickUp: (item: Order) => void;
  onConfirmPickedUp: (item: Order) => void;
  onConfirmDelivered: (item: Order) => void;
  seatDataMap?: Map<string, any>;
  claimed: boolean;
}

const DeliveryInfo: React.FC<DeliveryInfoProps> = ({ open, item, onClose, onPickUp, onConfirmDelivered, onConfirmPickedUp, seatDataMap, claimed }) => {
  const { t } = useTranslation();
  const { showToast } = useNotificationContext();

  const sendMail = async () => {
    try {
      await sendReceipt(item?.order_id || '', 'unsuccess');
      showToast({
        content: t(LANG_TEXT.SEND_DELIVERY_UNSUCCESSFUL_MAIL_SUCCESS),
        type: 'success',
      });
    } catch (error) {
      console.log('error:', error);
      showToast({
        content: t(LANG_TEXT.SEND_DELIVERY_UNSUCCESSFUL_MAIL_FAILED),
        type: 'error',
      });
    }
  };

  return (
    <CustomDrawer open={open} onClose={onClose} anchor="right">
      {item && (
        <>
          <Box padding="6px 20px" borderBottom="1px solid #E5E5E5">
            <IconButton onClick={onClose}>
              <img src={BackIcon} alt="back" />
              <Typography marginLeft="12px" color="#424242" fontWeight="500">
                {t(LANG_TEXT.ORDER_DELIVERY_INFORMATION)}
              </Typography>
            </IconButton>
          </Box>
          <Box flex="1 1 0%" overflow="auto" bgcolor="#F9FAFB" display="flex" flexDirection="column" gap="8px">
            <OrderIdSection item={item} />
            {item.order_status === OrderItemStatus.DELIVERING && (item?.email || item?.email_or_phone || item?.phone) && (
              <SeatInfor email={item.email || item.email_or_phone} phone={item.phone} giftInfo={item.gift_info} sendMail={sendMail} />
            )}
            <Transition item={item} type={item.type ?? 'normal'} />
            <OrderSummary item={item} type={item.type ?? 'normal'} />
            {item.promotion_foods && item.promotion_foods.length > 0 && <Transition item={item} type={'promotion'} seatDataMap={seatDataMap} />}
            {item.promotion_foods && item.promotion_foods.length > 0 && <OrderSummary item={item} type={'promotion'} />}
            <PaymentSummary item={item} />
            <PaymentMethod item={item} />
          </Box>
          <Box sx={{ boxShadow: '0px -2px 4px -2px #1018280F, 0px -4px 8px -2px #1018281A' }} padding="16px">
            <ActionButton item={item} onPickUp={onPickUp} onConfirmDelivered={onConfirmDelivered} onConfirmPickedUp={onConfirmPickedUp} claimed={claimed} />
          </Box>
        </>
      )}
    </CustomDrawer>
  );
};

export default DeliveryInfo;
